import * as React from "react";
import { forwardRef } from "react";
const SvgArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 5 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.37744 0.730459L0.0132339 4.82539H4.74165L2.37744 0.730459Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M2.99998 4.78125H1.69189V7.99523H2.99998V4.78125Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrow);
export default ForwardRef;
